import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-139e38b5")

_pushScopeId("data-v-139e38b5")
const _hoisted_1 = {
  key: 0,
  class: "wrap-tag"
}
const _hoisted_2 = { class: "wrap-text" }
const _hoisted_3 = /*#__PURE__*/_createVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM14.5 16H13V10.5C13 10.2239 12.7761 10 12.5 10H10.5C10.2239 10 10 10.2239 10 10.5C10 10.7761 10.2239 11 10.5 11H12V16H10.5C10.2239 16 10 16.2239 10 16.5C10 16.7761 10.2239 17 10.5 17H14.5C14.7761 17 15 16.7761 15 16.5C15 16.2239 14.7761 16 14.5 16ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM13 7.5C13 7.22386 12.7761 7 12.5 7H11.5C11.2239 7 11 7.22386 11 7.5V8.5C11 8.77614 11.2239 9 11.5 9H12.5C12.7761 9 13 8.77614 13 8.5V7.5Z",
    fill: "#007BC3"
  })
], -1)
const _hoisted_4 = { class: "wrap-warning mb-2 mt-1.5" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Tooltip = _resolveComponent("Tooltip")

  return (_openBlock(), _createBlock(_Fragment, null, [
    ($props.typeLabel === 'inline')
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          for: "element-input",
          class: ["block text-sm font-medium md:text-sm sm:text-sm lg:text-lg flex items-center wrap-label", $setup.classTextLabel]
        }, [
          ($props.mandatory)
            ? (_openBlock(), _createBlock("div", _hoisted_1, _toDisplayString($setup.t('required')), 1))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_2, [
            _createTextVNode(_toDisplayString($props.textLabel) + " ", 1),
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ]),
          ($props.hasHint)
            ? (_openBlock(), _createBlock(_component_Tooltip, {
                key: 1,
                textTooltip: $props.textToolTip,
                locationTooltip: "top"
              }, {
                default: _withId(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["textTooltip"]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_4, _toDisplayString($props.warningLabel), 1)
  ], 64))
})